/// <amd-module name="SuiteCommerce.Blog.TaxonomyNavigation.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.TaxonomyNavigation.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Collection"], function (require, exports, Backbone_1, TaxonomyNavigation_Taxonomy_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TaxonomyNavigationModel = /** @class */ (function (_super) {
        __extends(TaxonomyNavigationModel, _super);
        function TaxonomyNavigationModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(TaxonomyNavigationModel.prototype, "taxonomies", {
            get: function () {
                if (!this.get('taxonomies')) {
                    this.taxonomies = new TaxonomyNavigation_Taxonomy_Collection_1.TaxonomyNavigationTaxonomyCollection();
                }
                return this.get('taxonomies');
            },
            set: function (taxonomies) {
                this.set('taxonomies', taxonomies);
            },
            enumerable: true,
            configurable: true
        });
        return TaxonomyNavigationModel;
    }(Backbone_1.Model));
    exports.TaxonomyNavigationModel = TaxonomyNavigationModel;
});
